





















import { Vue, Component, Prop} from 'vue-property-decorator' 
import { Getter, Mutation, Action } from 'vuex-class'
import moment from 'moment'

import { Claim } from '@/core/enums'
import { sleep } from '@/core/utilities'
import { ICreateCouponArgs } from '@/core/api/functions/types'


@Component({ })
export default class InvitationForm extends Vue {

  @Action('createAndSendCoupon', {namespace: 'auth'}) createAndSendCoupon!: (args: ICreateCouponArgs) => Promise<boolean>

  valid = true
  bulkImport = 'Sebastiaan | sebastiaan@planhr.nl'
  company = ''
  notes = ''

  async sendInvitations () {
    if ((this.$refs['form'] as any).validate()) {
      const lines = this.bulkImport.split('\n')
      for (const line of lines) {
        const parts = line.split('|')
        const result: any = await this.createAndSendCoupon({
          coupon: {
            endDate: moment().add(1, 'month').toDate()
          },
          scope: {
            claims: [Claim.PREMIUM_USER],
            endDate: moment().add(1, 'year').toDate()
          },
          user: {
            email: parts[1].trim(),
            nickname: parts[0].trim()
          },
          notes: this.notes
        })
        console.log('Sent: ', result.success)
        await sleep(100)          
      }
    }
  }

  reset () {
    (this.$refs['form'] as any).reset()
  }
}
